import React, { useEffect, useState, useRef } from "react";
import { Box, Tab, Typography } from "@mui/material";
import { TabContext, TabPanel, TabList } from "@mui/lab";
import Header from "../Header";
import MenuBar from "../MenuBar";
import { styled } from "@mui/material/styles";
import PaymentTab from "./PaymentTab";
import Branding from "./Branding";
import { useAuth } from "../../context/API_Client";
import "../../pages/analytics/analytics.css";
import "./checkout.css";
import Footer from "../Footer";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { colorBrandObject } from "../../../constants/brandings";
import MonitorEnabledIcon from '../../../assets/svg/monitorEnabled.svg';
import MonitorDisabledIcon from '../../../assets/svg/monitorDisabled.svg';
import MobileEnabledIcon from '../../../assets/svg/mobileEnabled.svg';
import MobileDisabledIcon from '../../../assets/svg/mobileDisabled.svg';
import { iconDefaultColor } from "../../reusableComponents/constants";

const CustomTab = styled(Tab)(({ theme }) => ({
  fontFamily: "Poppins",
  fontSize: "14px !important",
}));

export default function Checkout() {
  const { merchantSettings, updateCheckoutSettings, getAccessToken } =
    useAuth();
  const [settings, setSettings] = useState();
  const [value, setValue] = useState("1");
  const [checkoutTheme, setCheckoutTheme] = useState({});
  const [
    checkoutDisabledAdditionalFields,
    setCheckoutDisabledAdditionalFields,
  ] = useState([]);
  const [
    checkoutDisabledPaymentMethodIds,
    setCheckoutDisabledPaymentMethodIds,
  ] = useState([]);
  const [checkoutToken, setCheckoutToken] = useState("");
  const [version, setVersion] = useState();
  const [mobile, setMobile] = useState(false);
  const [numberOfPaymentMethods, setNumberOfPaymentMethods] = useState(0);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const token = getAccessToken();
  const { getAllModalData, getPaymentMethod } = useAuth();
  const [categoryInfo, setCategoryInfo] = useState({});

  const [scale, setScale] = useState(1);
  const [translateX, setTranslateX] = useState(0);
  const [translateY, setTranslateY] = useState(0);

  var paymentMethodIds;
  var paymentMethodIdsInfo = {};
  var newPaymentMethodIdsInfo = [];
  var categories = {};

  useEffect(() => {
    const updateIframeStyle = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const originalWidth = 800;
      const originalHeight = 1280;
      const scaleX = windowWidth / originalWidth;
      const scaleY = windowHeight / originalHeight;
      const scaleFactor = Math.min(scaleX / 3, 1);
      const translateX = (windowWidth - originalWidth * scaleFactor) / 30;
      const translateY = (windowHeight - originalHeight * scaleFactor) / 30;
      setScale(scaleFactor);
      setTranslateX(translateX);
      setTranslateY(translateY);
    };
    window.addEventListener("resize", updateIframeStyle);
    updateIframeStyle();
  }, []);

  useEffect(() => {
    localStorage.removeItem("merchantSettings");
    merchantSettings(
      function (data) {
        setSettings(data);
        setCheckoutTheme(data?.checkoutTheme);
        setCheckoutDisabledAdditionalFields(
          data?.checkoutDisabledAdditionalFields
        );
        setCheckoutDisabledPaymentMethodIds(
          data?.checkoutDisabledPaymentMethodIds
        );
        setVersion(data?.version);
        setCheckoutToken(data?.checkoutToken);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  useEffect(() => {
    getAllModalData(
      function (data) {
        paymentMethodIds = data?.paymentMethodIds;
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
    getPaymentMethod(
      function (data) {
        paymentMethodIdsInfo = data;
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );

    for (let index = 0; index < paymentMethodIds?.length; index++) {
      newPaymentMethodIdsInfo.push(
        paymentMethodIdsInfo?.filter(
          (obj) => obj.id === paymentMethodIds[index]
        )
      );
    }
    let arr = [];
    for (let index = 0; index < newPaymentMethodIdsInfo?.length; index++) {
      if (newPaymentMethodIdsInfo[index][0]?.type !== "Paynow") {
        arr.push(newPaymentMethodIdsInfo[index]);
      }
    }
    newPaymentMethodIdsInfo = arr;

    for (let index = 0; index < newPaymentMethodIdsInfo.length; index++) {
      if (categories[newPaymentMethodIdsInfo[index][0]?.type]) {
        categories[newPaymentMethodIdsInfo[index][0]?.type].push(
          newPaymentMethodIdsInfo[index][0]
        );
      } else {
        categories[newPaymentMethodIdsInfo[index][0]?.type] = [
          newPaymentMethodIdsInfo[index][0],
        ];
      }
    }
    setCategoryInfo(categories);
  }, []);

  useEffect(() => {
    let num = 0;
    for (const key in categoryInfo) {
      if (
        checkoutDisabledPaymentMethodIds?.find(
          (ele) => ele === categoryInfo[key][0]?.id
        ) === undefined
      ) {
        num = num + 1;
        updateNumberOfPaymentMethods(num);
      }
    }
  }, [categoryInfo, checkoutDisabledPaymentMethodIds]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const updateCheckoutTheme = (name, value) => {
    setCheckoutTheme({
      ...checkoutTheme,
      [name]: value,
    });
    let obj = {
      ...checkoutTheme,
      [name]: value,
    };
    let payload = settings;
    payload = {
      ...payload,
      checkoutTheme: obj,
      version: version,
    };
    updateCheckoutSettings(
      payload,
      function (data) {
        setVersion(data.version);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };
  const updateCheckoutDisabledAdditionalFields = (enable, field) => {
    let arr = [];
    if (enable) {
      arr = checkoutDisabledAdditionalFields?.filter((ele) => ele != field);
      setCheckoutDisabledAdditionalFields(arr);
    } else {
      if (checkoutDisabledAdditionalFields === null) {
        arr = [field];
      } else {
        arr = [...checkoutDisabledAdditionalFields, field];
      }

      setCheckoutDisabledAdditionalFields(arr);
    }

    let payload = settings;
    payload = {
      ...payload,
      checkoutDisabledAdditionalFields: arr,
      version: version,
    };
    updateCheckoutSettings(
      payload,
      function (data) {
        setSettings(data);
        setVersion(data.version);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };
  const updateCheckoutDisabledPaymentMethodIds = (enable, paymentIdArray) => {
    let arr = [];

    if (enable) {
      arr = checkoutDisabledPaymentMethodIds;
      for (let i = 0; i < paymentIdArray?.length; i++) {
        arr = arr.filter((ele) => ele != paymentIdArray[i]);
      }
      setCheckoutDisabledPaymentMethodIds(arr);
    } else {
      if (checkoutDisabledPaymentMethodIds === null) {
        arr = paymentIdArray;
      } else {
        arr = [...checkoutDisabledPaymentMethodIds, ...paymentIdArray];
      }
      setCheckoutDisabledPaymentMethodIds(arr);
    }

    let payload = checkoutTheme;
    payload = {
      ...payload,
      checkoutDisabledPaymentMethodIds: arr,
      version: version,
    };
    updateCheckoutSettings(
      payload,
      function (data) {
        setSettings(data);
        setVersion(data?.version);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };

  const updateNumberOfPaymentMethods = (num) => {
    setNumberOfPaymentMethods(num);
  };

  const getCheckoutBaseUrl = () => {
    return process.env.REACT_APP_BASE_URL.replace("apis", "checkout").replace(
      "/v0",
      ""
    );
  };

  const [selectedEnv, setSelectedEnv] = useState("");
  useEffect(() => {
    setSelectedEnv(window.location.hostname.split(".")[0]);
  }, []);

  return (
    <>
      <div
        className="content-wrapper"
        style={{
          backgroundColor: "rgba(250, 250, 250, 1)",
          display: "flex",
          height: "80dvh",
          overflow: "hidden",
        }}
      >
        <div className="checkout-config-root">
          <div className="side-panel">
            <TabContext value={value}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <TabList onChange={handleChange} TabIndicatorProps={{
                  style: {
                    backgroundColor: colorBrandObject?.primaryButtonColor,
                  },
                }}>
                  <CustomTab
                    label="Payment Methods"
                    value="1"
                    disableRipple
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "16px",
                      fontWeight: 600,
                      color: `${colorBrandObject?.primaryButtonColor} !important`
                    }}
                  />
                  <CustomTab
                    label="Branding"
                    disableRipple
                    value="2"
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "16px",
                      fontWeight: 600,
                      color: `${colorBrandObject?.primaryButtonColor} !important`
                    }}
                  />
                </TabList>
              </Box>
              <TabPanel value="1" className="checkout-config-panel-contnet">
                <PaymentTab
                  disabledOptions={checkoutDisabledAdditionalFields}
                  updateDisabledOptions={updateCheckoutDisabledAdditionalFields}
                  disabledPaymentIds={checkoutDisabledPaymentMethodIds}
                  updateDisabledPaymentIds={
                    updateCheckoutDisabledPaymentMethodIds
                  }
                  numberOfPaymentMethods={numberOfPaymentMethods}
                  updateNumberOfPaymentMethods={updateNumberOfPaymentMethods}
                  categoryInfo={categoryInfo}
                />
              </TabPanel>
              <TabPanel value="2" className="checkout-config-panel-contnet">
                <Branding
                  theme={checkoutTheme}
                  updateTheme={updateCheckoutTheme}
                />
              </TabPanel>
            </TabContext>
          </div>
          <div
            style={{
              width: "100vw",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="mobile-desktop-selection-panel">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {selectedEnv === "merchant" && (
                  <div
                    style={{
                      width: "480px",
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      background: "rgba(254, 255, 230, 1)",
                      padding: "6px 10px 6px 16px",
                    }}
                  >
                    <img
                      src="/assets/info-circle-yellow.svg"
                      style={{ paddingRight: "6px", paddingTop: "2px" }}
                    />
                    <Typography className="labelSmall font-black-high">
                      Making any changes will get immediately applied and we
                      recommend you should first test such changes in sandbox
                      environment
                    </Typography>
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: selectedEnv === "merchant" && "fixed",
                    right: selectedEnv === "merchant" && 50,
                  }}
                >
                  <Typography
                    className="bodyB2RegularText"
                    sx={{ paddingRight: "16px" }}
                  >
                    PREVIEW
                  </Typography>
                  <div className="toggle-area">
                    <div onClick={() => setMobile(false)} style={{ stroke: iconDefaultColor }}>
                      {
                        !mobile
                          ? <MonitorEnabledIcon stroke={`${colorBrandObject?.primaryButtonColor}`} />
                          : <MonitorDisabledIcon stroke={`${colorBrandObject?.primaryButtonColor}`} />
                      }
                    </div>
                    <div onClick={() => setMobile(true)} style={{ stroke: iconDefaultColor }}>
                      {
                        mobile
                          ? <MobileEnabledIcon stroke={`${colorBrandObject?.primaryButtonColor}`} />
                          : <MobileDisabledIcon stroke={`${colorBrandObject?.primaryButtonColor}`} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="main-content">
              {checkoutToken && mobile ? (
                <div className="mobile-version">
                  <iframe
                    height={"750px"}
                    width={"380px"}
                    src={`${getCheckoutBaseUrl()}/?token=${checkoutToken}&spo=xyz`}
                    key={version}
                    style={{
                      WebkitTransform: `Scale(${scale}) translate(${translateX / 2
                        }px, ${0}px)`,
                      transformOrigin: "top left",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </div>
              ) : (
                <></>
              )}
              {checkoutToken && !mobile ? (
                <div className="desktop-version" style={{ marginLeft: "10%" }}>
                  <iframe
                    height={"800px"}
                    width={"1280px"}
                    src={`${getCheckoutBaseUrl()}/?token=${checkoutToken}&spo=xyz`}
                    key={version}
                    style={{
                      WebkitTransform: `Scale(${scale}) translate(${0}px, ${0}px)`,
                      transformOrigin: "top left",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
